
<script setup>
//#region Imports
import { ref, onBeforeMount, onUpdated, watch, reactive, getCurrentInstance, computed } from 'vue';
import { inject } from 'vue';
import axios from 'axios';
import Notification from "@/components/common/SnackBar.vue";
//#endregion

//#region Reactive
const loginState = inject('loginState');
const store = inject('store');

const skillAdminTab = ref(0);

const skillAdminData = reactive({
    loading: true,
    data: [],
    framework: null,
    frameworkItems: [],
    frameworkData: [],
    framework_providers: [],
    selectedProvider: 0,
    headers: [
      { text: 'Skill', value: 'name' },
      { text: 'Core Category', value: 'category' },
      { text: 'Type', value: 'type', width:"250px" },
      { text: 'Active', value: 'active', sortable: false, width:"150px" },
      { text: '', value: 'actions', sortable: false, width:"50px" }
    ],
    notification: {
      text: "",
      type: "success"
    },
    search: '',
    selectedTagType: null,
    extractRequests: [],
    extractData: [],
    extractDataHeaders: [
      { text: 'System Number', value: 'system_number' },
      { text: 'Document Name', value: 'doc_name' },
      { text: 'Status', value: 'doc_status_text' },
      { text: 'Doc Type', value: 'doc_type' },
      { text: 'Skills Extracted?', value: 'skills_extracted' },
    ],
    extractRequestsHeaders: [
      { text: '# Docs', value: 'doc_count' },
      { text: '# Pending', value: 'pending_docs' },
      { text: '# Failed', value: 'failed_docs' },
      { text: '# Complete', value: 'complete_docs' },
      { text: 'Request Status', value: 'request_status' },
      { text: 'Request Message', value: 'request_message' },
      { text: 'Request Time', value: 'request_time' },
      { text: 'Use OpenAI?', value: 'use_openAI' },
      { text: '', value: 'actions'}
    ],
    docDetailHeaders: [
      { text: 'System Number', value: 'reference' },
      { text: 'Document Name', value: 'doc_name' },
      { text: 'Status', value: 'status' },
      { text: 'Message', value: 'message' }
    ],
    extractDataSelected: [],
    status_filters: [],
    type_filters: [],
    selected_status: [],
    selected_type: [],
    show_existing: true,
    extractRequestId: null,
    refreshTimeout: null,
    extractRequestDetail: null,
    use_openAI: false
})
//#endregion

//#region Computed
//#endregion



//#region Methods

const validDocuments = () => {
  let filtered = skillAdminData.extractData.filter(d => skillAdminData.selected_type.includes(d.doc_type) && skillAdminData.selected_status.includes(d.doc_status_text));
  if(!skillAdminData.show_existing){
    filtered = filtered.filter(x => !x.skills_extracted)
  }
  return filtered;
};

function calcTags(provider_id){
  skillAdminData.selectedProvider = skillAdminData.framework_providers.find(x => x.framework_provider_id === provider_id);
}

function getFramework(){
  skillAdminData.skillLoading = true;
  axios.get("skills/framework")
  .then((resp) => {
    skillAdminData.framework = resp.data.framework;
    skillAdminData.frameworkItems = resp.data.items;
    skillAdminData.frameworkData = resp.data.tag_data;
    skillAdminData.framework_providers = resp.data.framework_providers;
    if(resp.data.framework.tag_type_id){
      skillAdminData.selectedTagType = resp.data.tag_data.tagTypes.find(x => x.tag_type_id ===  resp.data.framework.tag_type_id)
    }
    if(resp.data.framework.framework_provider_id){
      calcTags(resp.data.framework.framework_provider_id);
    }
  })
  .catch(err => {
      console.log(err);
      skillAdminData.skillLoading = false;
  });
}

function getAllSkills() {
  skillAdminData.skillLoading = true;
    axios.get("skills/getAllSkills/")
    .then((resp) => {
      skillAdminData.data = resp.data.skill_data;
    })
    .catch(err => {
        console.log(err);
        skillAdminData.skillLoading = false;
    });
}

function getInstance() {
  getFramework();
  //getAllSkills();
}

function triggerNotification(msg, type){
  skillAdminData.notification = {
    text: msg,
    type: type
  };
}

function toggleSkill(e, item){
  let data = {
    ...item,
    active: e
  }
  axios.post("skills/frameworkSkill", data)
  .then((resp) => {
    triggerNotification("Skill Updated Successfully","success");
  })
  .catch(err => {
    triggerNotification(err,"error");
  });  
}

function edit(item){
  console.log(item);
}

function changeTagType(e){
  skillAdminData.selectedTagType = skillAdminData.frameworkData.tagTypes.find(x => x.tag_type_id === e);
}

function changeCategory(e, item){
  let data = {
    ...item,
    mapping: e
  }
  axios.post("skills/mapFrameworkSkill", data)
  .then((resp) => {
    triggerNotification("Skill Updated Successfully","success");
  })
  .catch(err => {
    triggerNotification(err,"error");
  });  
}

function saveFrameworkConfig(){
  axios.post("skills/saveFrameworkConfig", skillAdminData.framework)
  .then((resp) => {
    skillAdminData.framework = resp.data;
    triggerNotification("Skill Framework Config Updated Successfully","success");
  })
  .catch(err => {
    triggerNotification(err,"error");
  });  
}

function toggleAll(event) {
  let valid = validDocuments();
  valid = valid.filter(x => !x.skills_extracted).map(object => object);
  event.value && skillAdminData.extractDataSelected.length !== valid.length ? skillAdminData.extractDataSelected = valid : skillAdminData.extractDataSelected = [];
}

function syncTags(){

  let data = {
    ...skillAdminData.framework,
    framework_provider_id: skillAdminData.selectedProvider.framework_provider_id
  }

  axios.post("skills/syncTags", data)
  .then((resp) => {
    triggerNotification("Skill Framework Config Synced Successfully","success");
  })
  .catch(err => {
    triggerNotification(err,"error");
  });  
}

function requestClientExtract(){
  skillAdminData.loading = true;

  let data = {
     framework_id: skillAdminData.framework.framework_id
  }

  axios.post("skills/requestClientExtractData", data)
  .then((resp) => {
    skillAdminData.extractRequests = resp.data.requests;
    skillAdminData.extractData = resp.data.documents;
    skillAdminData.status_filters = resp.data.statuses;
    skillAdminData.selected_status = resp.data.statuses;
    skillAdminData.type_filters = resp.data.doc_types;
    skillAdminData.selected_type = resp.data.doc_types;
    skillAdminData.loading = false;
  })
  .catch(err => {
    triggerNotification(err,"error");
  });  
}

function loadTabContent(){
  if(skillAdminTab.value === 1 && skillAdminData.extractData.length === 0){
    requestClientExtract();
  }
}

function createRequest(){
  let data = {
     framework_id: skillAdminData.framework.framework_id,
     items: skillAdminData.extractDataSelected.map(x => x.doc_id),
     use_openAI: skillAdminData.use_openAI
  }

  axios.post("skills/requestClientExtract", data)
  .then((resp) => {
    skillAdminData.extractRequestId = resp.data.framework_request_queue_id;
    startPolling();
  })
  .catch(err => {
    triggerNotification(err,"error");
  });    
}

function processSkillExtractRequest(item){

  let data = {
     framework_id: skillAdminData.framework.framework_id,
     framework_request_queue_id: item.framework_request_queue_id
  }

  skillAdminData.extractRequestId = item.framework_request_queue_id;

  axios.post("skills/startExtract", data)
  .then((resp) => {
    skillAdminData.extractDataSelected = [];
    startPolling();
  })
  .catch(err => {
    triggerNotification(err,"error");
  });   

}

function updateRequest(prop, val){

  skillAdminData.extractRequestDetail[prop] = val;
  switch(prop){
    case "use_openAI":
      skillAdminData.extractRequestDetail[prop] = val ? 1 : 0;
      break;
    case "status_id":
      switch(val){
        case -2:
          skillAdminData.extractRequestDetail.request_status = "Cancelled";
          skillAdminData.extractRequestDetail.message = "Request Manually Cancelled";
          break;
        case 0:
          skillAdminData.extractRequestDetail.request_status = "Pending";
          skillAdminData.extractRequestDetail.message = "Request Manually Paused";
          break;          
        case 2:
          skillAdminData.extractRequestDetail.request_status = "Processing";
          skillAdminData.extractRequestDetail.message = "Request Manually Resumed";
          break;          
      }
      break;
  }

  let data = { 
    ...JSON.parse(JSON.stringify(skillAdminData.extractRequestDetail))
  };

  delete data.docs;

  axios.post("skills/updateRequestState", data)
  .then((resp) => {
    triggerNotification("Save Successful","success");
    if(prop === "status_id" && val === 2){
      processSkillExtractRequest(skillAdminData.extractRequestDetail);
    }
  })
  .catch(err => {
    triggerNotification(err,"error");
  }); 
}

function loadRequest(id){
  skillAdminData.extractRequestId = id.framework_request_queue_id;
  skillAdminData.extractRequestDetail = id;
  //startPolling();
}

function startPolling(){
  if (skillAdminData.extractRequestId === null) {
    skillAdminData.refreshTimeout = null;
    return;
  }

  let data = {
     framework_id: skillAdminData.framework.framework_id,
     framework_request_queue_id: skillAdminData.extractRequestId
  }

  axios.post("skills/extractState", data)
  .then((resp) => {
    if(resp){
      skillAdminData.extractRequestDetail = resp.data;
      if (skillAdminData.extractRequestDetail.request_status === "Processing") {
        skillAdminData.refreshTimeout = setTimeout(startPolling, 3000);
      } else {
        skillAdminData.refreshTimeout = null;
      }      
    }
  })
  .catch(err => {
    triggerNotification(err,"error");
  }); 
}

function closeDetail(){
  skillAdminData.refreshTimeout = null;
  skillAdminData.extractRequestId = null;
}

function getStatusColor(val){
  switch (val){
    case -2: //killed
    case -1: //error
      return "red";
    case 0: //pending
    case 2: //processing
      return "amber";
    case 1: //complete/success
      return "green";
  }
}

//#endregion



//#region Component
onUpdated(() => {

})

onBeforeMount(() => {
    getInstance();
})
//#endregion
</script>
<template>
  <div>
    <v-tabs style="padding-top:15px; width:50%" v-model="skillAdminTab" @change="loadTabContent" grow color="#48A401" background-color="transparent">
      <v-tab class="tab ma-0 pa-0">
        Skill Framework Config
      </v-tab>
      <v-tab class="tab ma-0 pa-0">
        Skill Extraction
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="skillAdminTab" style="">
      <v-tab-item class="tabItem pa-4" style="padding-top:15px">
        <v-row dense v-if="skillAdminData.framework">
          <v-col cols="3">
            Tag Type
          </v-col>
          <v-col cols="9">
            <v-select clearable @change="changeTagType($event)" v-model="skillAdminData.framework.tag_type_id" :items="skillAdminData.frameworkData.tagTypes" item-value="tag_type_id" item-text="tag_type_name"></v-select>
          </v-col>
        </v-row>
        <v-row dense v-if="skillAdminData.framework">
          <v-col cols="3">
            Tag Grading Type
          </v-col>
          <v-col cols="9">
            <v-select clearable v-model="skillAdminData.framework.tag_grading_type_id" :items="skillAdminData.frameworkData.tagGradingTypes" item-value="tag_grading_type_id" item-text="name"></v-select>
          </v-col>
        </v-row>
        <v-row dense v-if="skillAdminData.framework">
          <v-col cols="3">
            Template Type
          </v-col>
          <v-col cols="9">
            <v-select clearable v-model="skillAdminData.framework.tmpl_id" :items="store.state.docs.docTypeSummary" item-value="tmpl_id" item-text="docType"></v-select>
          </v-col>
        </v-row>
        <v-row dense v-if="skillAdminData.framework">
          <v-col cols="3">
            Hierarchy Type
          </v-col>
          <v-col cols="9">
            <v-select clearable v-model="skillAdminData.framework.ht_id" :items="store.state.hierarchies.hierarchies" item-value="ht_id" item-text="label"></v-select>
          </v-col>
        </v-row>
        <v-row dense v-if="skillAdminData.framework">
          <v-col cols="3">
            Tag Classifier Type
          </v-col>
          <v-col cols="9">
            <v-select clearable v-model="skillAdminData.framework.tag_classifier_type_id" :items="skillAdminData.frameworkData.tagClassifierTypes" item-value="tag_classifier_type_id" item-text="name"></v-select>
          </v-col>
        </v-row>
        <v-row dense v-if="skillAdminData.framework && skillAdminData.framework_providers">
          <v-col cols="3">
            Skill Framework Provider
          </v-col>
          <v-col cols="9">
            <v-select @change="calcTags($event)" clearable v-model="skillAdminData.framework.framework_provider_id" :items="skillAdminData.framework_providers" item-value="framework_provider_id" item-text="framework_name"></v-select>
          </v-col>
        </v-row>
        <v-row v-if="skillAdminData.selectedTagType && skillAdminData.selectedProvider" dense>
          <v-col cols="12">
            <h4>Sync Skill Tags with Framework Provider</h4>
          </v-col>
          <v-col cols="12">
            {{ skillAdminData.selectedTagType.values.length }} tag(s) in Selected Tag Type<br/>
            {{ skillAdminData.selectedTagType.values.filter(x => x.inferred_from).length }} tag(s) inferred from a Framework Provider
            <br/>
            <span v-if="skillAdminData.selectedProvider">
              <hr/>              
              {{ skillAdminData.selectedProvider.framework_items.length }} tag(s) in Selected Framework Provider<br/>
              {{ skillAdminData.selectedProvider.framework_items.filter(x => !skillAdminData.selectedTagType.values.map(v => { return v.value}).includes(x.Name || x.Description)).length }} Framework Items not in Selected Skill Tag List
            </span>
          </v-col> 
          <v-col cols="12">
            <v-btn @click="syncTags" :disabled="skillAdminData.selectedProvider === 0">Sync Tags With Skill Framework</v-btn>
          </v-col>       
        </v-row>
        <v-row>
        <v-col cols="10">
        </v-col> 
        <v-col cols="2">
          <v-btn color="primary" @click="saveFrameworkConfig">Save</v-btn>
        </v-col> 
        </v-row> 
      </v-tab-item> 
      <v-tab-item class="tabItem pa-4" style="padding-top:15px">
        <div v-if="skillAdminData.loading">
          Please Wait... Loading...
          <br />
          <v-progress-circular
            :width="3"
            color="green"
            indeterminate
          ></v-progress-circular>
        </div>
        <div v-else>
          <div v-if="skillAdminData.extractRequestId === null">
            <v-data-table
              :headers="skillAdminData.extractRequestsHeaders"
              :items="skillAdminData.extractRequests"
              item-key="doc_id"
              class="elevation-1"
            >
              <template  v-slot:[`item.actions`]="{ item }">
                <v-icon @click="loadRequest(item)">mdi-magnify</v-icon>
              </template>
              <template  v-slot:[`item.use_openAI`]="{ item }">
                <v-icon :color="item.use_openAI === 1 ? 'green' : ''">{{ item.use_openAI === 1 ? 'mdi-check-bold' : 'mdi-close' }}</v-icon>
              </template>
              <template v-slot:[`item.request_status`]="{item}">
                <v-chip
                  class="mx-1 status-chip chipFont"
                  :color="getStatusColor(item.status_id)"
                  label
                  style="top: 2px; left:25px;"
                >
                {{ item.request_status }}
                </v-chip>
              </template>
            </v-data-table>
            <v-btn @click="skillAdminData.extractRequestId = -1">Create New Request</v-btn>
          </div>
          <div v-else-if="skillAdminData.extractRequestId === -1">
            <v-row dense>
              <v-col><v-btn @click="skillAdminData.extractRequestId = null">Back</v-btn></v-col>
            </v-row>
            <v-row dense style="display: flex; align-items: center;">
              <v-col cols="4">
                <v-autocomplete multiple v-model="skillAdminData.selected_status" :items="skillAdminData.status_filters"></v-autocomplete>
              </v-col> 
              <v-col cols="4">
                <v-autocomplete multiple v-model="skillAdminData.selected_type" :items="skillAdminData.type_filters"></v-autocomplete>
              </v-col> 
              <v-col cols="2">
                <v-switch v-model="skillAdminData.show_existing" label="Show Documents with Skills Extracted"></v-switch>
              </v-col>
              <v-col cols="2">
                <v-switch v-model="skillAdminData.use_openAI" label="Improve Content through OpenAI"></v-switch>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <v-data-table
                  v-model="skillAdminData.extractDataSelected"
                  :headers="skillAdminData.extractDataHeaders"
                  :items="validDocuments()"
                  item-key="doc_id"
                  show-select
                  class="elevation-1"
                  @toggle-select-all="toggleAll($event)"
                >
                  <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
                    <v-checkbox
                      v-if="!item.skills_extracted"
                      :input-value="isSelected"
                      @click.stop="select(!isSelected)"
                      color="primary"
                    ></v-checkbox>
                  </template>              
                  <template v-slot:[`item.skills_extracted`]="{ item }">
                    <v-icon
                      :color="item.skills_extracted ? 'green' : ''"
                    >
                      {{ item.skills_extracted ? 'mdi-check' : 'mdi-close' }}
                    </v-icon>
                  </template> 
                </v-data-table>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <v-spacer></v-spacer>
                <v-btn color="primary" :disabled="skillAdminData.extractDataSelected.length === 0" @click="createRequest">Create Extraction Request {{ skillAdminData.extractDataSelected.length > 0 ? ` - (${skillAdminData.extractDataSelected.length}) Docs` : '' }}</v-btn>
              </v-col>
            </v-row>
          </div>
          <div v-else> 
            <div v-if="skillAdminData.extractRequestDetail">
              <v-btn @click="closeDetail">Back</v-btn>
              <v-row class="pt-5" dense>
                <v-col cols="5">
                  <div style="display:inline-flex; align-items: flex-end;">
                    <b>Status:</b>
                    <v-chip
                      class="mx-1 status-chip chipFont"
                      :color="getStatusColor(skillAdminData.extractRequestDetail.status_id)"
                      label
                      style="top: 2px; left:25px;"
                    >
                      {{ skillAdminData.extractRequestDetail.request_status}}
                    </v-chip>
                    <div style="display: flex; position: relative; top: 4px; left: 35px;">
                      <v-icon @click="updateRequest('status_id', 2)" color="success" v-if="skillAdminData.extractRequestDetail.status_id !== 1" large title="Resume Processing">mdi-play-box-outline</v-icon>
                      <v-icon @click="updateRequest('status_id', 0)" color="amber" v-if="skillAdminData.extractRequestDetail.status_id === 2" large title="Pause">pause-box-outline</v-icon>
                      <v-icon @click="updateRequest('status_id', -2)" color="red" v-if="skillAdminData.extractRequestDetail.status_id !== -2 && skillAdminData.extractRequestDetail.status_id !== 1" large title="Kill Request">mdi-close-box-outline</v-icon>
                    </div>
                  </div>

                </v-col>
                <v-col cols="5">
                  <b>Timestamp:</b>{{ skillAdminData.extractRequestDetail.request_time }}
                </v-col>
                <v-col cols="2">
                  <v-switch :disabled="skillAdminData.extractRequestDetail.status_id === 1" @change="updateRequest('use_openAI', $event)" v-model="skillAdminData.extractRequestDetail.use_openAI" label="Improve Content through OpenAI"></v-switch>
                </v-col>
              </v-row>
              <v-row class="pt-5" dense>
                <v-col cols="4">
                  Complete: {{ skillAdminData.extractRequestDetail.complete_docs }}
                </v-col>
                <v-col cols="4">
                  Pending: {{ skillAdminData.extractRequestDetail.pending_docs }}
                </v-col>
                <v-col cols="4">
                  Error: {{ skillAdminData.extractRequestDetail.failed_docs }}
                </v-col>
              </v-row>   
              <v-row dense>
                <v-col cols="12">
                  <v-data-table
                    :headers="skillAdminData.docDetailHeaders"
                    :items="skillAdminData.extractRequestDetail.docs"
                    class="elevation-1"
                  >          
                    <template v-slot:[`item.status`]="{ item }">

                      <v-chip
                        class="mx-1 status-chip chipFont"
                        :color="getStatusColor(item.status)"
                        label
                        style="top: 2px; left:25px;"
                      >
                        <div v-if="item.status === 0">
                          <v-progress-circular
                            :width="3"
                            v-if="skillAdminData.extractRequestDetail.status_id === 2"
                            :size="20"
                            color="green"
                            indeterminate
                          ></v-progress-circular> Pending....
                        </div>
                        <div v-else-if="item.status === 1">
                          Complete
                        </div>
                        <div v-else-if="item.status === -1">
                          Error
                        </div>
                      </v-chip>


                    </template> 
                  </v-data-table>
                </v-col>
              </v-row>           
            </div>
          </div>
        </div>
      </v-tab-item>
    </v-tabs-items>
    <Notification :notification="skillAdminData.notification" />
  </div>
</template>
<style lang="scss" scoped>
</style>